<template>
    <div class="">
        <van-tabs v-model="active" @click="changeTab" line-width="1.5rem">
            <van-tab name="rec" title="推荐榜"></van-tab>
            <van-tab name="new" title="新游榜"></van-tab>
            <van-tab name="hot" title="人气榜"></van-tab>
        </van-tabs>
        <van-pull-refresh v-model="pullloading" @refresh="onRefresh" class="list">
            <ul v-if="show">
                <li v-for="(item,i) in list" :key="i" @click="gotoGame(item.app_id)">
                    <van-image class="icon" :src="item.icon" />
                    <span class="rank">{{ i + 1 }}</span>
                    <div class="cont">
                        <p class="name">{{ item.app_name }}</p>
                        <p class="intro" v-if="item.intro != ''" v-html="replaceAll(item.intro)"></p>
                    </div>
                    <div class="start_btn" v-if="isApp&&(item.conf&&item.conf.start_btn == 1)">
                        <van-button class="start" :loading="item.startLoading" @click.stop="start(i,item.conf)">启动</van-button>
                    </div>
                    <div class="start_btn" v-if="!isApp&&(item.conf&&item.conf.start_btn == 1&&item.conf.ios_game_url!='')&&isiOS">
                        <van-button class="start" :loading="item.startLoading" @click.stop="start2(i,item.conf)">启动</van-button>
                    </div>
                    <div class="start_btn" v-if="!isApp&&(item.conf&&item.conf.start_btn == 1&&item.conf.android_game_url!='')&&!isiOS">
                        <van-button class="start" :loading="item.startLoading" @click.stop="start2(i,item.conf)">启动</van-button>
                    </div>
                </li>
            </ul>
            <van-loading v-else></van-loading>
            <p class="nomore" v-if="show&&list.length == 0">
                <van-image class="no_goods" :src="require('../../assets/bx/acc/no_goods.png')"/>
                暂无数据
            </p>
            <p class="nomore" v-if="show&&list.length > 0">已经到底了</p>
        </van-pull-refresh>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                pullloading: false,
                active: 'rec',
                list: [],
                show: false
            }
        },
        computed: {
            sort() {
                return this.$route.params.sort
            },
            isApp() {
                return this.$store.state.isApp
            },
            isiOS() {
              var u = navigator.userAgent;
              if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
                return true
              } else {
                return false
              }
            },
        },
        created() {},
        mounted() {},
        methods: {
            replaceAll(str) {
                if (str) {
                    return str.replace(new RegExp('&nbsp;', 'g'), '');
                } else {
                    return ''
                }
            },
            changeTab(name) {
                if (name != this.sort) {
                    this.$router.replace({
                        name: 'rank',
                        params: {
                            sort: name
                        }
                    })
                }
            },
            gotoGame(app_id) {
                this.$router.push({
                  name: 'detail',
                  query: {
                    app_id
                  }
                })
            },
            getRank(otype) {
                this.show = false
                this.$Ajax('index/app-ranks', {
                    otype
                }, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.list = rs.data
                        setTimeout(() => {
                            this.show = true
                        }, 1000)
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.show = true
                    }, 1000)
                })
            },
            onRefresh() {
                var otype = '';
                if (this.active == 'rec') otype = 1;
                else if (this.active == 'new') otype = 2;
                else if (this.active == 'hot') otype = 3;
                this.getRank(otype)
            },
            //启动
            start(i,conf) {
                var that = this
                this.list[i].startLoading = true
                this.$forceUpdate()
                setTimeout(() => {
                    that.list[i].startLoading = false
                    this.$forceUpdate()
                }, 2000)
                if (this.isiOS) {
                    var e = {
                        game_url: conf.ios_game_url,
                        bundle_id: conf.ios_package,
                        store_id: conf.ios_appid,
                        game_page: conf.page,
                        open_type: conf.otype
                    }
                    window.webkit.messageHandlers.startGameWebToNative.postMessage(JSON.stringify(e));
                } else {
                    var e = {
                        game_url: conf.android_game_url,
                        bundle_id: conf.android_package,
                        game_page: conf.page,
                        open_type: conf.otype
                    }
                    window.android.startGameWebToNative(JSON.stringify(e));
                }
            },
            start2(i,conf) {
                var that = this
                this.list[i].startLoading = true
                this.$forceUpdate()
                setTimeout(() => {
                    that.list[i].startLoading = false
                    this.$forceUpdate()
                }, 2000)
                if (this.isiOS) {
                    window.location.href = conf.ios_game_url
                }else {
                    window.open(conf.android_game_url)
                }
            }
        },
        watch: {
            sort: {
                immediate: true,
                handler(e) {
                    this.active = e
                }
            },
            active: {
                immediate: true,
                handler(e) {
                    var otype = '';
                    if (e == 'rec') otype = 1;
                    else if (e == 'new') otype = 2;
                    else if (e == 'hot') otype = 3;
                    this.getRank(otype)
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .van-tabs {
        z-index: 10;
        position: fixed;
        top: 5rem;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 525px;
        padding: 0 2rem;
        background-color: #fff;

        /deep/.van-tabs__wrap {
            height: 3.4rem;
        }

        /deep/.van-tab {
            font-size: 1.5rem;
            color: #555;
            padding: 1.4rem 0 .8rem;
            line-height: unset;

            &.van-tab--active {
                color: #F66F30;
            }
        }

        /deep/.van-tabs__nav--line {
            padding-bottom: 1.8rem;
        }

        /deep/.van-tabs__line {
            bottom: 1.8rem;
            background-color: #F66F30;
        }
    }

    /deep/.van-loading {
        margin: 2rem auto;
        display: flex;
        justify-content: center;
    }

    .list {
        padding-top: 3.5rem;

        li {
            padding: 1.2rem 1rem;
            border-bottom: 1px solid #e9e9e9;
            cursor: pointer;
            display: flex;
            align-items: flex-start;

            .icon {
                width: 7rem;
                height: 7rem;
                border-radius: 1rem;
                overflow: hidden;
            }

            .rank {
                display: inline-block;
                width: 2rem;
                text-align: center;
                margin: 0 .6rem;
                line-height: 1.4rem;
                font-size: 1.2rem;
                color: #000;
                padding: 0.25rem 0;
                border-radius: .2rem;
            }

            .cont {
                flex: 1;

                .name {
                    font-size: 1.4rem;
                    color: #000;
                    font-weight: 700;
                    margin-bottom: .5rem;
                }

                .intro {
                    color: #bebebe;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;

                    img,
                    .img,
                    .image {
                        display: none;
                    }

                    /deep/img,
                    /deep/.img,
                    /deep/.image {
                        display: none;
                    }

                    p {

                        img,
                        .img,
                        .image {
                            display: none;
                        }

                        /deep/img,
                        /deep/.img,
                        /deep/.image {
                            display: none;
                        }
                    }
                }
            }

            .start_btn {
                height: 7rem;
                display: flex;
                align-items: center;
                margin-left: 2rem;
            }

            .start {
                width: 8rem;
                height: 2.8rem;
                background-color: var(--theme);
                border: none;
                border-radius: 10rem;
                color: #fff;
                font-size: 1.2rem;
            }

            &:nth-child(1) {
                .rank {
                    background-color: #FF5E5E;
                    color: #fff;
                    transform: scale(0.9);
                }
            }

            &:nth-child(2) {
                .rank {
                    background-color: #5EB4FF;
                    color: #fff;
                    transform: scale(0.9);
                }
            }

            &:nth-child(3) {
                .rank {
                    background-color: #FFB45E;
                    color: #fff;
                    transform: scale(0.9);
                }
            }

            &:nth-last-child(1) {
                border: none;
            }
        }
    }

    .nomore {
        margin: 1rem 0;
        font-size: 1.4rem;
        color: #999;
        text-align: center;
        .no_goods {
          display: block;
          margin: 3rem auto 0;
          width: 21rem;
          height: 13.4rem;
        }
    }
</style>